<!-- 
  详情页 - 客户 合同订单
  props:
    id: 详情id
  emit:
    openDetail: 打开详情页
 -->

<template>
	<div class="v-tabs notes-list">
		<div class="head">
      <div class="total">
        累计{{page.total}}次合同订单
      </div>
      <div class="inline-item">
        <el-date-picker
          v-model="date"
          size="small"
          type="daterange"
          style="width:180px"
          unlink-panels
          value-format="yyyy-MM-dd"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          @change="datepicker"
          >
        </el-date-picker>
      </div>
    </div>
    <div class="content" ref="content">
      <ul class="item-list">
        <li class="item center" v-if="!tableData.length">暂无数据</li>
        <li class="item" v-for="item in tableData" :class="{'hc-red': item.isRed}">
          <span class="date">{{item.addTime}}</span>
          <div class="order">
            <div class="id">
              <i class="ico green">单</i>
              <a @click="openDetail(item.id, item.isRed)">{{item.name}}</a>
              <a @click="openDetail(item.id, item.isRed)">{{item.contractNo}}</a>
            </div>
            <div class="good">
              <span class="thumb">
                <img :src="item.productImg" alt="">
              </span>
              <span class="title">{{item.productKind}}种商品 共{{item.productNum}}件</span>
              <span class="price">¥{{item.amount}}</span>
            </div>
            <div class="response">负责人：{{item.userName}}</div>
            <span class="status">{{item.statusStr}}</span>
          </div>
        </li>
      </ul>
    </div>
    <div class="load-more">
      <template v-if="showLoadmore">
        <i class="el-icon-loading"></i>
        加载更多
      </template>
      <template v-if="!showLoadmore && page.total>page.size">没有更多</template>
    </div>
	</div>
</template>

<script>
import * as api from 'src/api'
import { mapActions } from 'vuex'

export default {
  created () {
    this.getList()
  },
  props: {
    id: {
      type: Number
    },
    loading: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      tableData: [],
      date: [],
      // 分页信息
      page: {
        size: 10,
        total: '',
        page: 1,
        rows: 1
      }
    }
  },
  computed: {
    // 是否显示加载更多
    showLoadmore () {
      if (this.page.total > this.page.size && this.page.rows > this.page.page) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    ...mapActions([
      'setRedStatus'
    ]),
    datepicker (val) {
      this.page.page = 1
      if (val) {
        this.date = val
      } else {
        this.date = []
      }
      this.getList()
    },
    openDetail (id, isRed) {
      this.setRedStatus(isRed === true)
      this.$emit('openDetail', 'contractApi', id)
    },
    getList () {
      const time = this.date.length && this.date[0]
      let url = '/contractApi/getCustomerContract.html'
      let params = {
        customerId: this.id,
        addTime: time ? this.date : [],
        page: this.page.page,
        pageSize: this.page.size
      }
      api.post(url, params, (data) => {
        this.page.total = data.pageHelper.rowsCount
        this.page.rows = data.pageHelper.pageTotal

        // 通过page.page来判断当前是刷新还是下拉加载更多
        if (this.page.page === 1) {
          this.tableData = data.result
        } else {
          this.tableData = this.tableData.concat(data.result)
        }
      })
    },
    // 加载更多
    loadmore () {
      this.page.page++
      this.getList()
    }
  },
  watch: {
    loading () {
      if (this.page.rows > this.page.page) {
        this.loadmore()
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .v-tabs {
    .head {
      .inline-item {
        width: 210px;
      }
    }
  }
  .notes-list {
    .id {
      padding-left: 40px;
      padding-bottom: 5px;
      position: relative;
      height: auto!important;
      .ico {
        position: absolute;
        left: 0;
      }
      a {
        display: block;
        line-height: 1;
        padding-top: 10px;
        &+a {
          padding-top: 5px;
          font-size: 13px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// customer-contract.vue?604f15ab